import React from "react";

export default function Logo({ variant = "dark" }) {
  const stroke = variant === "light" ? "#F5E9CF" : "#1E1330";
  const accent1 = "#C4F542";
  const accent2 = "#E85D50";
  return (
    <span className="fp-logo" aria-label="Flowplanar">
      <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={variant === "light" ? "#1E1330" : "#1E1330"} />
        <path d="M14 46 L14 18 L30 18" stroke={accent1} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 32 L26 32" stroke={accent1} strokeWidth="5" strokeLinecap="round" />
        <circle cx="44" cy="22" r="4" fill={accent2} />
        <circle cx="50" cy="38" r="4" fill={accent1} />
        <circle cx="40" cy="46" r="4" fill="#F5E9CF" />
        <path d="M44 22 L50 38 L40 46" stroke="#F5E9CF" strokeWidth="1.5" strokeDasharray="2 3" />
      </svg>
      <span className="fp-logo__wordmark" style={{ color: stroke }}>Flowplanar</span>
    </span>
  );
}
